module.exports = __webpack_public_path__ + "img/renyuanquxiang.963f0e1a.png";